import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import Bonus from 'pages/bonus/bonus.component';
import { z } from 'zod';

const bonusSearchSchema = z.object({
  status: z.string().optional(),
  bonusType: z.string().optional(),
  expirationDate: z.string().optional(),
  idBonus: z.string().or(z.number()).optional(),
  hideNavigation: z.string().optional(),
  orderBy: z.string().optional(),
});

export const Route = createFileRoute(
  '/_auth/_layout_with_full_navigation/bonus-promotions',
)({ component: Bonus, validateSearch: zodValidator(bonusSearchSchema) });
